function Footer() {
    return (
      <footer className='justify-content-center'>
        <div>© {(new Date().getFullYear())} Inan Celis. <u>Crafted by yours truly</u></div>
      </footer>
      
    )
}

export default Footer;